export const Items: import('../../../sim/dex-items').ModdedItemDataTable = {
	abilityshield: {
		inherit: true,
		isNonstandard: "Past",
	},
	abomasite: {
		inherit: true,
		isNonstandard: null,
	},
	absolite: {
		inherit: true,
		isNonstandard: null,
	},
	absorbbulb: {
		inherit: true,
		isNonstandard: "Past",
	},
	adamantcrystal: {
		inherit: true,
		isNonstandard: "Past",
	},
	adamantorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	adrenalineorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	aerodactylite: {
		inherit: true,
		isNonstandard: null,
	},
	aggronite: {
		inherit: true,
		isNonstandard: null,
	},
	aguavberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	airballoon: {
		inherit: true,
		isNonstandard: "Past",
	},
	alakazite: {
		inherit: true,
		isNonstandard: null,
	},
	altarianite: {
		inherit: true,
		isNonstandard: null,
	},
	ampharosite: {
		inherit: true,
		isNonstandard: null,
	},
	apicotberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	assaultvest: {
		inherit: true,
		isNonstandard: "Past",
	},
	audinite: {
		inherit: true,
		isNonstandard: null,
	},
	auspiciousarmor: {
		inherit: true,
		isNonstandard: "Past",
	},
	banettite: {
		inherit: true,
		isNonstandard: null,
	},
	beastball: {
		inherit: true,
		isNonstandard: "Past",
	},
	beedrillite: {
		inherit: true,
		isNonstandard: null,
	},
	berrysweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	bignugget: {
		inherit: true,
		isNonstandard: "Past",
	},
	bigroot: {
		inherit: true,
		isNonstandard: "Past",
	},
	bindingband: {
		inherit: true,
		isNonstandard: "Past",
	},
	blacksludge: {
		inherit: true,
		isNonstandard: "Past",
	},
	blastoisinite: {
		inherit: true,
		isNonstandard: null,
	},
	blunderpolicy: {
		inherit: true,
		isNonstandard: "Past",
	},
	boosterenergy: {
		inherit: true,
		isNonstandard: "Past",
	},
	bottlecap: {
		inherit: true,
		isNonstandard: "Past",
	},
	cameruptite: {
		inherit: true,
		isNonstandard: null,
	},
	cellbattery: {
		inherit: true,
		isNonstandard: "Past",
	},
	chandelurite: {
		inherit: true,
		isNonstandard: null,
	},
	charizarditex: {
		inherit: true,
		isNonstandard: null,
	},
	charizarditey: {
		inherit: true,
		isNonstandard: null,
	},
	chesnaughtite: {
		inherit: true,
		isNonstandard: null,
	},
	chimechite: {
		inherit: true,
		isNonstandard: null,
	},
	chippedpot: {
		inherit: true,
		isNonstandard: "Past",
	},
	choiceband: {
		inherit: true,
		isNonstandard: "Past",
	},
	choicespecs: {
		inherit: true,
		isNonstandard: "Past",
	},
	clearamulet: {
		inherit: true,
		isNonstandard: "Past",
	},
	clefablite: {
		inherit: true,
		isNonstandard: null,
	},
	cloversweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	cornerstonemask: {
		inherit: true,
		isNonstandard: "Past",
	},
	covertcloak: {
		inherit: true,
		isNonstandard: "Past",
	},
	crabominite: {
		inherit: true,
		isNonstandard: null,
	},
	crackedpot: {
		inherit: true,
		isNonstandard: "Past",
	},
	custapberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	damprock: {
		inherit: true,
		isNonstandard: "Past",
	},
	darkranite: {
		inherit: true,
		isNonstandard: "Past",
	},
	dawnstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	delphoxite: {
		inherit: true,
		isNonstandard: null,
	},
	destinyknot: {
		inherit: true,
		isNonstandard: "Past",
	},
	diveball: {
		inherit: true,
		isNonstandard: "Past",
	},
	dracoplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	dragalgite: {
		inherit: true,
		isNonstandard: "Past",
	},
	dragoninite: {
		inherit: true,
		isNonstandard: null,
	},
	dragonscale: {
		inherit: true,
		isNonstandard: "Past",
	},
	drampanite: {
		inherit: true,
		isNonstandard: null,
	},
	dreadplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	dreamball: {
		inherit: true,
		isNonstandard: "Past",
	},
	dubiousdisc: {
		inherit: true,
		isNonstandard: "Past",
	},
	duskball: {
		inherit: true,
		isNonstandard: "Past",
	},
	duskstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	earthplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	eelektrossite: {
		inherit: true,
		isNonstandard: "Past",
	},
	ejectbutton: {
		inherit: true,
		isNonstandard: "Past",
	},
	ejectpack: {
		inherit: true,
		isNonstandard: "Past",
	},
	electirizer: {
		inherit: true,
		isNonstandard: "Past",
	},
	electricseed: {
		inherit: true,
		isNonstandard: "Past",
	},
	emboarite: {
		inherit: true,
		isNonstandard: null,
	},
	enigmaberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	eviolite: {
		inherit: true,
		isNonstandard: "Past",
	},
	excadrite: {
		inherit: true,
		isNonstandard: null,
	},
	expertbelt: {
		inherit: true,
		isNonstandard: "Past",
	},
	falinksite: {
		inherit: true,
		isNonstandard: "Past",
	},
	fastball: {
		inherit: true,
		isNonstandard: "Past",
	},
	feraligite: {
		inherit: true,
		isNonstandard: null,
	},
	figyberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	firestone: {
		inherit: true,
		isNonstandard: "Past",
	},
	fistplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	flameorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	flameplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	floatstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	floettite: {
		inherit: true,
		isNonstandard: null,
	},
	flowersweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	friendball: {
		inherit: true,
		isNonstandard: "Past",
	},
	froslassite: {
		inherit: true,
		isNonstandard: null,
	},
	galaricacuff: {
		inherit: true,
		isNonstandard: "Past",
	},
	galaricawreath: {
		inherit: true,
		isNonstandard: "Past",
	},
	galladite: {
		inherit: true,
		isNonstandard: null,
	},
	ganlonberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	garchompite: {
		inherit: true,
		isNonstandard: null,
	},
	gardevoirite: {
		inherit: true,
		isNonstandard: null,
	},
	gengarite: {
		inherit: true,
		isNonstandard: null,
	},
	glalitite: {
		inherit: true,
		isNonstandard: null,
	},
	glimmoranite: {
		inherit: true,
		isNonstandard: null,
	},
	goldbottlecap: {
		inherit: true,
		isNonstandard: "Past",
	},
	golisopite: {
		inherit: true,
		isNonstandard: "Past",
	},
	golurkite: {
		inherit: true,
		isNonstandard: null,
	},
	grassyseed: {
		inherit: true,
		isNonstandard: "Past",
	},
	greatball: {
		inherit: true,
		isNonstandard: "Past",
	},
	greninjite: {
		inherit: true,
		isNonstandard: null,
	},
	grepaberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	gripclaw: {
		inherit: true,
		isNonstandard: "Past",
	},
	griseouscore: {
		inherit: true,
		isNonstandard: "Past",
	},
	griseousorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	gyaradosite: {
		inherit: true,
		isNonstandard: null,
	},
	hawluchanite: {
		inherit: true,
		isNonstandard: null,
	},
	healball: {
		inherit: true,
		isNonstandard: "Past",
	},
	hearthflamemask: {
		inherit: true,
		isNonstandard: "Past",
	},
	heatranite: {
		inherit: true,
		isNonstandard: "Past",
	},
	heatrock: {
		inherit: true,
		isNonstandard: "Past",
	},
	heavyball: {
		inherit: true,
		isNonstandard: "Past",
	},
	heavydutyboots: {
		inherit: true,
		isNonstandard: "Past",
	},
	heracronite: {
		inherit: true,
		isNonstandard: null,
	},
	hondewberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	houndoominite: {
		inherit: true,
		isNonstandard: null,
	},
	iapapaberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	icestone: {
		inherit: true,
		isNonstandard: "Past",
	},
	icicleplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	icyrock: {
		inherit: true,
		isNonstandard: "Past",
	},
	insectplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	ironball: {
		inherit: true,
		isNonstandard: "Past",
	},
	ironplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	jabocaberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	kangaskhanite: {
		inherit: true,
		isNonstandard: null,
	},
	keeberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	kelpsyberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	laggingtail: {
		inherit: true,
		isNonstandard: "Past",
	},
	lansatberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	leafstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	levelball: {
		inherit: true,
		isNonstandard: "Past",
	},
	liechiberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	lifeorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	lightclay: {
		inherit: true,
		isNonstandard: "Past",
	},
	loadeddice: {
		inherit: true,
		isNonstandard: "Past",
	},
	lopunnite: {
		inherit: true,
		isNonstandard: null,
	},
	loveball: {
		inherit: true,
		isNonstandard: "Past",
	},
	lovesweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	lucarionite: {
		inherit: true,
		isNonstandard: null,
	},
	luminousmoss: {
		inherit: true,
		isNonstandard: "Past",
	},
	lureball: {
		inherit: true,
		isNonstandard: "Past",
	},
	lustrousglobe: {
		inherit: true,
		isNonstandard: "Past",
	},
	lustrousorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	luxuryball: {
		inherit: true,
		isNonstandard: "Past",
	},
	magmarizer: {
		inherit: true,
		isNonstandard: "Past",
	},
	magoberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	maliciousarmor: {
		inherit: true,
		isNonstandard: "Past",
	},
	manectite: {
		inherit: true,
		isNonstandard: null,
	},
	marangaberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	masterball: {
		inherit: true,
		isNonstandard: "Past",
	},
	masterpieceteacup: {
		inherit: true,
		isNonstandard: "Past",
	},
	meadowplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	medichamite: {
		inherit: true,
		isNonstandard: null,
	},
	meganiumite: {
		inherit: true,
		isNonstandard: null,
	},
	meowsticite: {
		inherit: true,
		isNonstandard: null,
	},
	metalalloy: {
		inherit: true,
		isNonstandard: "Past",
	},
	metronome: {
		inherit: true,
		isNonstandard: "Past",
	},
	micleberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	mindplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	mirrorherb: {
		inherit: true,
		isNonstandard: "Past",
	},
	mistyseed: {
		inherit: true,
		isNonstandard: "Past",
	},
	moonball: {
		inherit: true,
		isNonstandard: "Past",
	},
	moonstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	muscleband: {
		inherit: true,
		isNonstandard: "Past",
	},
	nestball: {
		inherit: true,
		isNonstandard: "Past",
	},
	netball: {
		inherit: true,
		isNonstandard: "Past",
	},
	normalgem: {
		inherit: true,
		isNonstandard: "Past",
	},
	ovalstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	parkball: {
		inherit: true,
		isNonstandard: "Past",
	},
	petayaberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	pidgeotite: {
		inherit: true,
		isNonstandard: null,
	},
	pinsirite: {
		inherit: true,
		isNonstandard: null,
	},
	pixieplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	pokeball: {
		inherit: true,
		isNonstandard: "Past",
	},
	pomegberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	poweranklet: {
		inherit: true,
		isNonstandard: "Past",
	},
	powerband: {
		inherit: true,
		isNonstandard: "Past",
	},
	powerbelt: {
		inherit: true,
		isNonstandard: "Past",
	},
	powerbracer: {
		inherit: true,
		isNonstandard: "Past",
	},
	powerherb: {
		inherit: true,
		isNonstandard: "Past",
	},
	powerlens: {
		inherit: true,
		isNonstandard: "Past",
	},
	powerweight: {
		inherit: true,
		isNonstandard: "Past",
	},
	premierball: {
		inherit: true,
		isNonstandard: "Past",
	},
	prettyfeather: {
		inherit: true,
		isNonstandard: "Past",
	},
	prismscale: {
		inherit: true,
		isNonstandard: "Past",
	},
	protectivepads: {
		inherit: true,
		isNonstandard: "Past",
	},
	protector: {
		inherit: true,
		isNonstandard: "Past",
	},
	psychicseed: {
		inherit: true,
		isNonstandard: "Past",
	},
	punchingglove: {
		inherit: true,
		isNonstandard: "Past",
	},
	qualotberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	quickball: {
		inherit: true,
		isNonstandard: "Past",
	},
	rarebone: {
		inherit: true,
		isNonstandard: "Past",
	},
	razorclaw: {
		inherit: true,
		isNonstandard: "Past",
	},
	razorfang: {
		inherit: true,
		isNonstandard: "Past",
	},
	reapercloth: {
		inherit: true,
		isNonstandard: "Past",
	},
	redcard: {
		inherit: true,
		isNonstandard: "Past",
	},
	repeatball: {
		inherit: true,
		isNonstandard: "Past",
	},
	ribbonsweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	ringtarget: {
		inherit: true,
		isNonstandard: "Past",
	},
	rockyhelmet: {
		inherit: true,
		isNonstandard: "Past",
	},
	roomservice: {
		inherit: true,
		isNonstandard: "Past",
	},
	rowapberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	rustedshield: {
		inherit: true,
		isNonstandard: "Past",
	},
	rustedsword: {
		inherit: true,
		isNonstandard: "Past",
	},
	sablenite: {
		inherit: true,
		isNonstandard: null,
	},
	safariball: {
		inherit: true,
		isNonstandard: "Past",
	},
	safetygoggles: {
		inherit: true,
		isNonstandard: "Past",
	},
	salacberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	scizorite: {
		inherit: true,
		isNonstandard: null,
	},
	scovillainite: {
		inherit: true,
		isNonstandard: null,
	},
	sharpedonite: {
		inherit: true,
		isNonstandard: null,
	},
	shedshell: {
		inherit: true,
		isNonstandard: "Past",
	},
	shinystone: {
		inherit: true,
		isNonstandard: "Past",
	},
	skarmorite: {
		inherit: true,
		isNonstandard: null,
	},
	skyplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	slowbronite: {
		inherit: true,
		isNonstandard: null,
		shortDesc: "If held by a Slowbro (not Galarian Slowbro), this item allows it to Mega Evolve.",
	},
	smoothrock: {
		inherit: true,
		isNonstandard: "Past",
	},
	snowball: {
		inherit: true,
		isNonstandard: "Past",
	},
	souldew: {
		inherit: true,
		isNonstandard: "Past",
	},
	spelltag: {
		inherit: true,
		isNonstandard: null,
	},
	splashplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	spookyplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	sportball: {
		inherit: true,
		isNonstandard: "Past",
	},
	starfberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	starminite: {
		inherit: true,
		isNonstandard: null,
	},
	starsweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	steelixite: {
		inherit: true,
		isNonstandard: null,
	},
	stickybarb: {
		inherit: true,
		isNonstandard: "Past",
	},
	stoneplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	strangeball: {
		inherit: true,
		isNonstandard: "Past",
	},
	strawberrysweet: {
		inherit: true,
		isNonstandard: "Past",
	},
	sunstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	sweetapple: {
		inherit: true,
		isNonstandard: "Past",
	},
	syrupyapple: {
		inherit: true,
		isNonstandard: "Past",
	},
	tamatoberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	tartapple: {
		inherit: true,
		isNonstandard: "Past",
	},
	terrainextender: {
		inherit: true,
		isNonstandard: "Past",
	},
	throatspray: {
		inherit: true,
		isNonstandard: "Past",
	},
	thunderstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	timerball: {
		inherit: true,
		isNonstandard: "Past",
	},
	toxicorb: {
		inherit: true,
		isNonstandard: "Past",
	},
	toxicplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	tyranitarite: {
		inherit: true,
		isNonstandard: null,
	},
	ultraball: {
		inherit: true,
		isNonstandard: "Past",
	},
	unremarkableteacup: {
		inherit: true,
		isNonstandard: "Past",
	},
	upgrade: {
		inherit: true,
		isNonstandard: "Past",
	},
	utilityumbrella: {
		inherit: true,
		isNonstandard: "Past",
	},
	venusaurite: {
		inherit: true,
		isNonstandard: null,
	},
	victreebelite: {
		inherit: true,
		isNonstandard: null,
	},
	waterstone: {
		inherit: true,
		isNonstandard: "Past",
	},
	weaknesspolicy: {
		inherit: true,
		isNonstandard: "Past",
	},
	wellspringmask: {
		inherit: true,
		isNonstandard: "Past",
	},
	whiteherb: {
		inherit: true,
		onAnyAfterMove() {
			// Desync: proceed from Parting Shot's point of view
			this.queue.insertChoice({
				choice: 'event',
				event: 'WhiteHerb',
				order: 99, // before switches
				pokemon: this.effectState.target,
			});
		},
		onWhiteHerb(pokemon) {
			((this.effect as any).onStart as (p: Pokemon) => void).call(this, this.effectState.target);
		},
	},
	widelens: {
		inherit: true,
		isNonstandard: "Past",
	},
	wikiberry: {
		inherit: true,
		isNonstandard: "Past",
	},
	wiseglasses: {
		inherit: true,
		isNonstandard: "Past",
	},
	zapplate: {
		inherit: true,
		isNonstandard: "Past",
	},
	zoomlens: {
		inherit: true,
		isNonstandard: "Past",
	},
};
